// AggregatedDataTable.js
import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';

const sampleData = [
  { ID: 1, timestamp: '1/17/22 1:00', PV_production: 0.0, PV_consumption: 4.3 },
  { ID: 1, timestamp: '1/17/22 2:00', PV_production: 0.0, PV_consumption: 4.4 },
  { ID: 1, timestamp: '1/17/22 3:00', PV_production: 0.0, PV_consumption: 5.0 },
  { ID: 1, timestamp: '1/17/22 4:00', PV_production: 0.0, PV_consumption: 3.5 },
  { ID: 1, timestamp: '1/17/22 5:00', PV_production: 0.0, PV_consumption: 3.1 },
  { ID: 1, timestamp: '1/17/22 6:00', PV_production: 0.0, PV_consumption: 2.9 },
  { ID: 1, timestamp: '1/17/22 7:00', PV_production: 0.0, PV_consumption: 2.8 },
  { ID: 1, timestamp: '1/17/22 8:00', PV_production: 0.03, PV_consumption: 2.63 },
  { ID: 1, timestamp: '1/17/22 9:00', PV_production: 0.75, PV_consumption: 3.05 },
  { ID: 1, timestamp: '1/17/22 10:00', PV_production: 1.74, PV_consumption: 3.34 },
  { ID: 1, timestamp: '1/17/22 11:00', PV_production: 3.7, PV_consumption: 7.4 },
  { ID: 1, timestamp: '1/17/22 12:00', PV_production: 8.13, PV_consumption: 6.93 },
  { ID: 1, timestamp: '1/17/22 13:00', PV_production: 6.04, PV_consumption: 7.54 },
  { ID: 1, timestamp: '1/17/22 14:00', PV_production: 3.79, PV_consumption: 7.49 },
  { ID: 1, timestamp: '1/17/22 15:00', PV_production: 1.79, PV_consumption: 6.89 },
  { ID: 1, timestamp: '1/17/22 16:00', PV_production: 0.52, PV_consumption: 6.72 },
  { ID: 1, timestamp: '1/17/22 17:00', PV_production: 0.01, PV_consumption: 5.41 },
  { ID: 1, timestamp: '1/17/22 18:00', PV_production: 0.0, PV_consumption: 8.0 },
  { ID: 1, timestamp: '1/17/22 19:00', PV_production: 0.0, PV_consumption: 7.6 },
  { ID: 1, timestamp: '1/17/22 20:00', PV_production: 0.0, PV_consumption: 5.9 },
  { ID: 1, timestamp: '1/17/22 21:00', PV_production: 0.0, PV_consumption: 7.6 },
  { ID: 1, timestamp: '1/17/22 22:00', PV_production: 0.0, PV_consumption: 7.5 },
  { ID: 1, timestamp: '1/17/22 23:00', PV_production: 0.0, PV_consumption: 6.7 },
  { ID: 1, timestamp: '2/17/22 0:00', PV_production: 0.0, PV_consumption: 6.3 },
];


const AggregatedDataTable = () => {

  return (
    <div>
      <Typography variant="h5" sx={{ fontWeight: 'bold', textAlign: 'left', marginTop: 1, marginBottom: 2 }}>
        Sample Dataset
      </Typography>

      <TableContainer component={Paper} sx={{ width: '100%', margin: 'auto', maxHeight: 600, overflow: 'auto' }}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              {/* <TableCell align="center">ID</TableCell> */}
              <TableCell align="center">Timestamp</TableCell>
              <TableCell align="center">Consumption</TableCell>
              <TableCell align="center">PV Production</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sampleData.map((row, index) => (
              <TableRow key={index}>
                {/* <TableCell align="center">{row.ID}</TableCell> */}
                <TableCell align="center">{row.timestamp}</TableCell>
                <TableCell align="center">{row.PV_consumption}</TableCell>
                <TableCell align="center">{row.PV_production}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default AggregatedDataTable;
